//-------------------------------------------------------------------------------------------------- Imports
import { CSSProperties } from "react";
import parse from "html-react-parser";
import { kebabCase } from "lodash";



//-------------------------------------------------------------------------------------------------- Interfaces
interface MarkdownPreviewerProps {
    mdSource: string;
    styles?: CSSProperties;
    textStyle?: CSSProperties;
    h1Style?: CSSProperties;
    h2Style?: CSSProperties;
    h3Style?: CSSProperties;
    h4Style?: CSSProperties;
    linkStyle?: CSSProperties;
};



//-------------------------------------------------------------------------------------------------- Component
const MarkdownPreviewer = (props: MarkdownPreviewerProps) => {
    const { mdSource, styles, textStyle, h1Style, h2Style, h3Style, h4Style, linkStyle } = props;
    const splitSources = mdSource.split("|").map(obj => obj.trim());

    const regexMarkdownBold = /\*\*(.+?)\*\*/;
    const regexMarkdownBold2 = /__.*?__/;
    const regexMarkdownLink = /\[.*?\]\((.*?)\)/;
    const regexTextBetweenBrackets = /\[.*?\]/;
    const regexTextBetweenParenthesis = /\(.*?\)/;



    const cssPropertyToCssString = (style: any): string => {
        return Object.keys(style || {}).reduce((accumulator, key) => {
            const cssKey = kebabCase(key);
            const cssValue = style[key];
    
            if (typeof cssValue !== "number") {
                return `${accumulator}${cssKey}:${cssValue.replace("'", "")};`;
            }
    
            return `${accumulator}${cssKey}:${cssValue};`;
        }, '');
    };
    
    const replaceAllLinksToAElement = (str: string) => {
        let matchsLinks: RegExpMatchArray | null;
    
        while ((matchsLinks = str.match(regexMarkdownLink))) {
            let matchLink = matchsLinks[0].match(regexTextBetweenParenthesis);
            let matchLinkDesc = matchsLinks[0].match(regexTextBetweenBrackets);
            let link = "#";
            let description = "#";
    
            if (matchLink && matchLinkDesc) {
                link = matchLink[0].substring(1, matchLink[0].length - 1);
                description = matchLinkDesc[0].substring(1, matchLinkDesc[0].length - 1);
            }
    
            // Uso de comillas dobles para el estilo CSS
            str = str.replace(matchsLinks[0], `<a href="${link}" style="${cssPropertyToCssString(linkStyle)}" target="_blank">${description}</a>`);
        };
    
        return str;
    };

    const replaceBoldsToBElement = (str: string) => {
        let matchsBolds: RegExpMatchArray | null;
        let boldText: string = "";

        while ((matchsBolds = str.match(regexMarkdownBold)) || (matchsBolds = str.match(regexMarkdownBold2))) {
            boldText = matchsBolds[0].substring(2, matchsBolds[0].length - 2);

            str = str.replace(matchsBolds[0], `<b style="color: #0e5ea5">${boldText}</b>`);
        };

        return str;
    };



    return (
        <div style={styles && styles}>
            {
                splitSources.map((str) => {
                    if (str.startsWith("#### ")) {
                        return (
                            <h4 style={h4Style && h4Style}>
                                {parse(replaceBoldsToBElement(replaceAllLinksToAElement(str.substring(4))))}
                            </h4>
                        );
                    }
                    else if (str.startsWith("### ")) {
                        return (
                            <h3 style={h3Style && h3Style}>
                                {parse(replaceBoldsToBElement(replaceAllLinksToAElement(str.substring(3))))}
                            </h3>
                        );
                    }
                    else if (str.startsWith("## ")) {
                        return (
                            <h2 style={h2Style && h2Style}>
                                {parse(replaceBoldsToBElement(replaceAllLinksToAElement(str.substring(2))))}
                            </h2>
                        );
                    }
                    else if (str.startsWith("# ")) {
                        return (
                            <h1 style={h1Style && h1Style}>
                                {parse(replaceBoldsToBElement(replaceAllLinksToAElement(str.substring(1))))}
                            </h1>
                        );
                    }
                    else {
                        return <p style={textStyle && textStyle}>
                            {parse(replaceBoldsToBElement(replaceAllLinksToAElement(str)))}
                        </p>
                    }
                })
            }
        </div>
    );
};



//-------------------------------------------------------------------------------------------------- Exports
export default MarkdownPreviewer;
